/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini200,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini400,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini401,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini500,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParams,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniQueryParams,
} from "../../types/individualPaymentVanzoliniController/PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini.ts";

export const postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParams>;

export const postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniQueryParamsSchema =
  z
    .object({
      serialPaymentId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini200>;

/**
 * @description Regra de negócio violada
 */
export const postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini500>;

export const postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationResponse>;
